import React from "react";
import { IbssComponent } from "../../../../Components/Core/BaseComponent/IbssComponent";
import { appContext } from "../../../../AppContext";
import IbssSvgIcon from "../../../../Components/Icons/SvgIcon/IbssSvgIcon";
import { Icons } from "../../../../Common/AllsvgIcons";

export class SpaceAnalyticsLeftHeader extends IbssComponent<IProps, IState>
{
    constructor(props: IProps)
    {
        super(props);
        this.state = { lightModeTheme: appContext().state.lightModeTheme };
    }

    public componentDidMount(): void
    {
        appContext().state.autoMap(this, i => ({ lightModeTheme: i.lightModeTheme }));
    }


    private getHeading(groupBy: string, isAnyBuildingOrFloor: boolean, isAllBuildingOptions: boolean, isTotalWorkSpaceType: boolean, buildingClassType: string, numOfSummaries: number): IHeading
    {
        if (groupBy == "Floor" && (!isAnyBuildingOrFloor || !isAllBuildingOptions))
        {
            return {
                icon: Icons.FloorIcon,
                title: this.makePlural('Floor', numOfSummaries),
            };
        }

        if (groupBy == "Building" && isAnyBuildingOrFloor && isAllBuildingOptions && isTotalWorkSpaceType)
        {
            return {
                icon: Icons.building,
                title: this.makePlural('Building', numOfSummaries),
            };
        }

        if (groupBy == 'Building')
        {
            return {
                icon: Icons.WorkspaceIcon,
                title: `${buildingClassType} ${this.makePlural('Space', numOfSummaries)}`,
            };
        }

        if (groupBy != "Floor" && !isAllBuildingOptions && isTotalWorkSpaceType)
        {
            return {
                icon: Icons.WorkspaceIcon,
                title: this.makePlural('Space', numOfSummaries),
            };
        }

        if (groupBy == "Space" && (!isAllBuildingOptions || !isTotalWorkSpaceType))
        {
            return {
                icon: Icons.desk,
                title: this.makePlural('Space', numOfSummaries),
            };
        }

        return {
            icon: Icons.desk,
            title: '',
        };
    }

    private makePlural(word: string, count: number): string
    {
        return (word + (count > 1 ? 's' : ''));
    }

    public render(): JSX.Element
    {
        const { lightModeTheme } = this.state;
        const { numOfSummaries, spaceType, classType, workSpaceType, buildingOptions, floorIdOrAny, groupBy } = this.props
        const heading = this.getHeading(groupBy, floorIdOrAny == "Any", buildingOptions == "All", workSpaceType == "Total", classType, numOfSummaries);

        return (
            <div className="card-result p-10 my-6">
                <div className="d-flex justify-content-center p-10">
                    <div className="">
                        {
                            numOfSummaries == 0 ?
                                ""
                                :
                                <IbssSvgIcon fontSize="medium" className="mr-2">
                                    {heading.icon}
                                </IbssSvgIcon>
                        }

                    </div>
                    <div className="mx-10 result-item-center">
                        <div className="text-ui-20">{numOfSummaries}</div>
                        <div className="text-ui-14">
                            {heading.title}
                        </div>
                    </div>
                    <div>
                        <IbssSvgIcon fontSize="large">{Icons.RightArrowIcon}</IbssSvgIcon>
                    </div>
                </div>
            </div>
        );
    }
}

export default SpaceAnalyticsLeftHeader;

export interface IProps
{
    numOfSummaries: number;
    spaceType?: string;
    classType: string;
    workSpaceType: string;
    buildingOptions: string;
    floorIdOrAny: string;
    groupBy: string;
}

export interface IState
{
    lightModeTheme: boolean;
}

export interface IHeading
{
    icon: JSX.Element;
    title: string;
}
